<template>
  <Transition name="dialog" appear>
    <slot />
  </Transition>
</template>

<style lang="scss">
.dialog {
  &-enter-active {
    @apply duration-300 ease-in;

    .dialog-overlay {
      @apply duration-300 opacity-0;
    }

    .dialog-panel {
      @apply duration-300 opacity-0 scale-75;
    }
  }

  &-enter-to {
    .dialog-overlay {
      @apply opacity-100;
    }

    .dialog-panel {
      @apply opacity-100 scale-100;
    }
  }

  &-leave-active {
    @apply duration-300 ease-out;

    .dialog-overlay, .dialog-panel {
      @apply duration-300;
    }
  }

  &-leave-to {
    .dialog-overlay {
      @apply opacity-0;
    }

    .dialog-panel {
      @apply opacity-0 scale-75;
    }
  }
}
</style>
